var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperty: require('./_object-dp').f });



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es6.object.define-property.js
// module id = 1107
// module chunks = 0